import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { useDispatch } from 'react-redux';
import { effects as moderationEffects } from 'lib/entities/moderation';
import { effects as userEffects } from 'lib/entities/user';
import { effects as featureUserEffects } from 'features/user/slice';
import streamWidget from 'global/StreamWidget/slice';
import { mainProfileEvents } from 'features/user/analytics/ProfileAnalytics';
import { useQueryClient } from '@tanstack/react-query';
import QueryProvider from 'global/QueryProvider';
import { Modal } from './styled';

const contentWording = (username) => ({
  block: `${username} tidak bisa mengirim pesan ke kamu atau menemukan profile, dan post kamu. 
    ${username} tidak akan diberi tahu bahwa kamu telah memblokirnya.`,
  unblock: `${username} dapat melihat post kamu, follow dan mengirimkan pesan. 
    ${username} tidak akan diberi tahu bahwa kamu membuka blokirnya.`,
});

interface ModalBlockUnblockUserProps {
  username: string;
  userId: number;
  type: 'block' | 'unblock';
  onCancel: (val?: any) => void;
  [key: string]: any;
}

function ModalBlockUnblockUser({
  username,
  userId,
  type,
  onCancel = () => {},
  ...props
}: ModalBlockUnblockUserProps) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  /**
   * @param {Event} e
   */
  const handleBlockUnblock = async (e) => {
    e.stopPropagation();
    queryClient.invalidateQueries();

    if (type === 'block') {
      mainProfileEvents.onUserProfileBlockConfirmed();
    } else {
      mainProfileEvents.onUserProfileUnblockConfirmed();
    }
    const request =
      type === 'block'
        ? // @ts-ignore
          await dispatch(moderationEffects.blockUser(userId))
        : // @ts-ignore
          await dispatch(moderationEffects.unblockUser(userId));

    // @ts-ignore
    const { error } = request.payload;

    if (!error) {
      if (type === 'block') {
        mainProfileEvents.onUserProfileSuccessfullyBlocked();
      } else {
        mainProfileEvents.onUserProfileSuccessfullyUnblocked();
      }
      // @ts-ignore
      dispatch(userEffects.getUserProfile(username));
      dispatch(featureUserEffects.getPinnedPost({ username }));
      // @ts-ignore
      dispatch(streamWidget.actions.setFilterParam({}));
      onCancel(e);
    }
  };

  return (
    <Modal
      {...props}
      onCancel={onCancel}
      title={
        <Text
          size="16px"
          height="40px"
          weight="bold"
          color={color.black}
          align="center"
        >
          Block {username}
        </Text>
      }
      centered
      footer={[
        <Button key="cancel" block height="40px" onClick={onCancel}>
          <Text align="center" family="bold">
            Cancel
          </Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="primary"
          height="40px"
          margin="0px !important"
          onClick={handleBlockUnblock}
        >
          <Text align="center" color={color.light}>
            {type === 'block' ? 'Block' : 'Unblock'}
          </Text>
        </Button>,
      ]}
      width={334}
    >
      <Text align="center">{contentWording(username)[type]}</Text>
    </Modal>
  );
}

function ModalBlockUnblockWithQuery(props: ModalBlockUnblockUserProps) {
  return (
    <QueryProvider>
      <ModalBlockUnblockUser {...props} />
    </QueryProvider>
  );
}

export default ModalBlockUnblockWithQuery;
